"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERC721Enumerable__factory = void 0;

var _contracts = require("@ethersproject/contracts");

/* Autogenerated file. Do not edit manually. */

/* tslint:disable */

/* eslint-disable */
class ERC721Enumerable__factory extends _contracts.ContractFactory {
  constructor(signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static connect(address, signerOrProvider) {
    return new _contracts.Contract(address, _abi, signerOrProvider);
  }

}

exports.ERC721Enumerable__factory = ERC721Enumerable__factory;
const _abi = [{
  inputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "approved",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Approval",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "operator",
    type: "address"
  }, {
    indexed: false,
    internalType: "bool",
    name: "approved",
    type: "bool"
  }],
  name: "ApprovalForAll",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "approve",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "getApproved",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    internalType: "address",
    name: "operator",
    type: "address"
  }],
  name: "isApprovedForAll",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "ownerOf",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "safeTransferFrom",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "_data",
    type: "bytes"
  }],
  name: "safeTransferFrom",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "bool",
    name: "approved",
    type: "bool"
  }],
  name: "setApprovalForAll",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "transferFrom",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    internalType: "uint256",
    name: "index",
    type: "uint256"
  }],
  name: "tokenOfOwnerByIndex",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "totalSupply",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "uint256",
    name: "index",
    type: "uint256"
  }],
  name: "tokenByIndex",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}];
const _bytecode = "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";